export default "__VITE_ASSET__Lm_3XdZX__"